export default __webpack_public_path__ + "static/media/email_sticker.2f08c881.gif";